import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { TTeam } from '../types/team.type';

/**
 *
 */
export const CreateTeamValidationSchema = z.object({
  name: z.string().min(1, 'Team name is required'),
  userIds: z.array(z.string()).optional(),
});
export type TCreateTeamValidation = z.infer<typeof CreateTeamValidationSchema>;
export type TCreateTeamPayload = TCreateTeamValidation;
export type TCreateTeamResponse = ApiResponse<TTeam>;

export const createTeam = async (payload: TCreateTeamPayload): Promise<TCreateTeamResponse> => {
  const url = '/team/manage';

  return axiosInstance.post(url, payload);
};

/**
 *
 */
type UseCreateTeamOptions = {
  mutationConfig?: TypedMutationConfig<typeof createTeam, AxiosErrorCustom>;
};

export const useCreateTeam = ({ mutationConfig }: UseCreateTeamOptions) => {
  const { ...restConfig } = mutationConfig || {};

  return useMutation<TCreateTeamResponse, AxiosErrorCustom, TCreateTeamPayload>({
    mutationFn: createTeam,
    ...restConfig,
  });
};
